import { render, staticRenderFns } from "./ConfigureProfile.vue?vue&type=template&id=4f2ed51a&"
import script from "./ConfigureProfile.vue?vue&type=script&lang=js&"
export * from "./ConfigureProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports